

import React, {Component, Fragment} from 'react'
import { connect } from 'react-redux'
import {Button} from 'reactstrap';
import { BsPlus } from "react-icons/bs";
import LongPressComponent from '../../../../../components/longPress/LongPressComponent';
import ItemCount from '../../misc/ItemCount';

var saleCommonUtility = require('../../../../../utils/domain/sales/saleCommonUtility');
var saleContextUtil = require('../../../utils/saleContextUtil');

class PlusToolbarButton extends Component 
{
    constructor(props)
    {
        super(props);

        this.state = {};
        this.state.showItemCountDialogue = false;
    }

    render()
    {
        return (<>
                    <LongPressComponent disabled={!this.canAddQuantity()}
                                onClick={()=>{this.onAddition(1);}}
                                onLongPress={()=>
                                {
                                    this.state.showItemCountDialogue = true;
                                    this.setState({});
                                }} style={{minWidth:'33.33%'}}>
                        <Button className='btn-action' disabled={!this.canAddQuantity()} style={{fontSize:'2rem', minHeight:'8vh', minWidth:'100%', borderRadius: 0}}>
                            <BsPlus/>
                        </Button>
                    </LongPressComponent>
                    {this.renderItemQuantityDialogue()}
                </>)
    }

    renderItemQuantityDialogue()
    {
        if (!this.state.showItemCountDialogue)
            return null;
        
        let saleContext = this.props.saleContext;
        let rootItem = saleContext.selectedItems[0]

        return <ItemCount   quantity={rootItem.quantity} caption={rootItem.caption}
                            onClose={()=>
                                {
                                    this.state.showItemCountDialogue = false;
                                    this.setState({})
                                }}
                            onSubmit={(value) =>
                            {
                                this.state.showItemCountDialogue = false;
                                
                                if (value == rootItem.quantity)
                                {
                                    this.setState({});
                                    return;
                                }

                                if (value == 0)
                                {
                                    this.onSubtraction(rootItem.quantity);
                                    return;
                                }

                                if (rootItem.quantity > value)
                                {
                                    this.onSubtraction(rootItem.quantity - value);
                                    return;
                                }

                                this.onAddition(value - rootItem.quantity);
                            }}/>
    }

    canAddQuantity()
    {
        return (saleCommonUtility.canEditSale(this.props.saleContext) && 
                this.props.saleContext.selectedItems.length == 1);
    }

    onAddition(count)
    {
        let saleContext = this.props.saleContext;

        let rootItem = saleContext.selectedItems[0]
        this.changeQuantityBy(rootItem, count);
        saleContextUtil.raiseSaleContextSaleChangeEvent(true);
    }

    onSubtraction(count)
    {
        let saleContext = this.props.saleContext;
        let sale = saleContext.sale;

        let rootItem = saleContext.selectedItems[0]
        this.changeQuantityBy(rootItem, -1 * count);
        sale.saleItems = sale.saleItems.filter (i => i.quantity > 0);
        this.props.saleContext.selectedItems = this.props.saleContext.selectedItems.filter(i => i.quantity > 0);
        saleContextUtil.raiseSaleContextSaleChangeEvent(true);
    }

    changeQuantityBy(item, byQuantity)
    {
        item.quantity = item.quantity + byQuantity;
        item.saleItems.forEach(subItem =>
        {
            this.changeQuantityBy(subItem, byQuantity);
        });
    }
}

const mapStateToProps = state => 
{
    return { 
                saleContext: state.saleContext,
                saleChangedDateTime: state.saleContext.saleChangedDateTime
           }
}

export default connect(mapStateToProps)(PlusToolbarButton)
